/* eslint-disable no-param-reassign */
window.TV2 = window.TV2 || {};

window.TV2.initTv2Play = (id) => {
  const play = document.getElementById(`tv2-contentbox-tv2play-${id}`);
  const left = play.querySelector('.tv2play__scrollbutton--left');
  const right = play.querySelector('.tv2play__scrollbutton--right');
  const content = play.querySelector('.tv2play__content');
  const items = play.querySelectorAll('.tv2play__item') || [];

  function updateButtonDisabledStates() {
    left.disabled = content.scrollLeft === 0;
    right.disabled = content.scrollLeft + content.clientWidth >= content.scrollWidth;
  }

  if (content.scrollWidth > content.clientWidth) {
    let itemWidth = 460;

    if (items.length !== 0) {
      itemWidth = items[0].offsetWidth;
    }

    updateButtonDisabledStates();

    /**
     * setTimeout is used because we need to wait for the scrollLeft prop to
     * update, as 'scroll-behavior: smooth' animates the scrolling
     */
    right.addEventListener('click', function () {
      content.scrollLeft += itemWidth;
      setTimeout(function () {
        updateButtonDisabledStates();
      }, 300);
    });

    left.addEventListener('click', function () {
      content.scrollLeft -= itemWidth;
      setTimeout(function () {
        updateButtonDisabledStates();
      }, 300);
    });
  }
};
